import home from "./en/home";
import settings from "./en/settings";
import HomePage from "./en/HomePage";
import MinLivesStilHeader from "./en/MinLivesStilHeader";
import WelcomePage from "./en/WelcomePage";
import LoginPage from "./en/LoginPage";
import navigation from "./en/navigation";
import goals from "./en/goals";
import lifestyle from "./en/lifestyle";
import work from "./en/work";

export default {
  home: home,
  settings: settings,
  HomePage: HomePage,
  MinLivesStilHeader: MinLivesStilHeader,
  WelcomePage: WelcomePage,
  LoginPage: LoginPage,
  navigation: navigation,
  goals: goals,
  lifestyle: lifestyle,
  work: work,
  aiChat: {
    guided: {
      question: 'Question',
      startInstruction: 'Click Question 1 below and I will answer using all the relevant knowledge I can find.',
      goalStatement: 'My goal is to {goals}. I need help with this.',
      priorityPrompt: 'Would you like me to help you prioritize what to do?',
      planPrompt: 'Would you like me to create a concrete lifestyle plan for you?',
      yes: 'Yes, please',
      no: 'No, thanks',
      priorityYesMessage: 'Yes, please help me prioritize what to do.',
      priorityNoMessage: 'No, thanks. I do not want help prioritizing right now.',
      planYesMessage: 'Yes, please create a concrete lifestyle plan for me.',
      planNoMessage: 'No, thanks. Do not create a lifestyle plan right now.',
      finish: 'Finish',
      thanks: 'Thank you. I am ready to start following my lifestyle plan.',
      declinedThanks: 'Thank you for the help. I will finish the conversation here.',
    },
  },
  welcome: "Welcome! Great that you're going to try the Bwell method. Good luck!",
  start: "Get started",
  emailLabel: "Email:",
  passwordLabel: "Password:",
  login: "Log in",
  emailRequired: "Please enter your email.",
  emailInvalid: "Invalid email format",
  passwordRequired: "Please enter your password.",
  invalidCredentialsTitle: "Invalid login credentials",
  invalidCredentialsMessage: "No user found with those credentials.",
  noInternetTitle: "No internet connection",
  noInternetMessage: "It seems you don't have an internet connection.",
  serverErrorTitle: "Could not connect to server",
  serverErrorMessage: "Check your internet connection and try again later.",
  unknownErrorTitle: "An unknown error occurred",
  unknownErrorMessage: "Try again later. Contact support if the error persists.",
  privacyPolicy: "Read our privacy policy",
  forgotPassword: "Forgot password?",
  workMessage1: "Bwell gives you as an employee a personal lifestyle plan.",
  workMessage2: "And helps you decide how you want your physical, mental, and social life to be going forward. Things that are important to feel well!",
  featureNotAvailable: "This feature is not available in this test version.",
  select: "SELECT",
  stopNow: "Stop now!",
  youHaveNotAnswered: "You have not answered the question.",
  youHaveNotAnsweredSatisfaction: "You have not answered whether you are satisfied or want to improve.",
  continueAnyway: "Continue anyway",
  close: "Close"
};
